<div class="mode-toggle">
    <button type="button" class="mode-btn" [class.active]="!not" (click)="not = false">
        {{ 'notToggle.normal' | translate }}
    </button>
    <button type="button" class="mode-btn niet" [class.active]="not" (click)="not = true">
        {{ 'notToggle.niet' | translate }}
    </button>
</div>
